import React, { useCallback } from 'react';

import { useChatController } from '~/components/AiChat/controller/ChatControllerContext';
import { ClaimChatControllerProvider } from '~/components/AiChat/controller/useClaimChatController';
import { HistoryViewContainer } from '~/components/AiChat/SideBarDialog/components/HistoryView/HistoryViewContainer';

import { useEmbeddedChatContext } from '../EmbeddedChatContext';

const ClaimHistoryView: React.FC = () => {
  const { searchQuery, setSearchQuery, closeSearch } = useEmbeddedChatContext();
  const { history } = useChatController({ required: true });

  const handleChatSelect = useCallback(
    async (chatId: string) => {
      await history?.open(chatId);
      closeSearch();
    },
    [history, closeSearch]
  );

  if (!history) return null;

  return (
    <HistoryViewContainer
      history={history}
      onChatSelect={handleChatSelect}
      searchQuery={searchQuery}
      onSearchQueryChange={setSearchQuery}
      showSearchField={false}
    />
  );
};

export const HistoryView: React.FC = () => (
  <ClaimChatControllerProvider>
    <ClaimHistoryView />
  </ClaimChatControllerProvider>
);
